if (typeof window.gettext === "undefined") {
  window.gettext = function(str) { return str; };
}

if (typeof window.ngettext === "undefined") {
  window.ngettext = function(singular, plural, n) {
	  return n > 1 ? plural : singular;
  };
}

if (typeof window.pgettext === "undefined") {
  window.pgettext = function(context, str) { return str; };
}